import React, { useState, useEffect } from "react";
import Layout from "Components/Layout";
import { Helmet } from "react-helmet";
import CommonClasses from "Styles/Common.module.css";
import SkeletonLoad from "Components/TableLoad/load";
import { Services } from "Services";
import { warningSwal, Success } from "Util/Toast";
import { TablePagination } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";

const Configs = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState(null);
    const [editedValue, setEditedValue] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const fetchConfigs = () => {
        setLoading(true);
        Services.getConfigs("GET", null, token)
            .then((response) => {
                setLoading(false);
                if ((response && response.Status === 1) || (response && response.status === 1)) {
                    const list = response.ConfigDetails || [];
                    setData(Array.isArray(list) ? list : []);
                } else if ((response && response.Status === 0) || (response && response.status === 0)) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("Something went wrong. Please try again.");
                console.error(err);
            });
    };

    useEffect(() => {
        fetchConfigs();
        // eslint-disable-next-line
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Layout Active={"Configs"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Configs</title>
            </Helmet>
            <div className={CommonClasses["Container"]}>
                <div>
                    <h1 style={{ color: '#FF0D0D' }}>CONFIGS</h1>
                </div>
                <div className={CommonClasses["wrapper"]}>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={[
                                "Config Key",
                                "Config Value",
                                "Actions",
                            ]}
                        />
                    ) : data.length > 0 ? (
                        <div className={CommonClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Config Key</th>
                                        <th>Config Value</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data
                                        .slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        .map((item, index) => {
                                            const isEditing = editingKey === (item.ConfigKey || String(index));
                                            return (
                                                <tr key={item.ConfigKey || index}>
                                                    <td>{item.ConfigKey || '-'}</td>
                                                    <td>
                                                        {isEditing ? (
                                                            <input
                                                                type="text"
                                                                value={editedValue}
                                                                onChange={(e) => setEditedValue(e.target.value)}
                                                                style={{ width: '20%', textAlign: 'center', padding: '10px', border: '1px solid #e1e1e1', borderRadius: '6px' }}
                                                            />
                                                        ) : (
                                                            item.ConfigValue || '-'
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className={CommonClasses["Action-btns"]}>
                                                            {isEditing ? (
                                                                <>
                                                                    <button
                                                                        className={CommonClasses["btnUpdate"]}
                                                                        onClick={async () => {
                                                                            try {
                                                                                setLoading(true);
                                                                                const body = {
                                                                                    ConfigID: item.ConfigId || item.ConfigID || item.ID || null,
                                                                                    ConfigKey: item.ConfigKey,
                                                                                    ConfigValue: editedValue,
                                                                                };
                                                                                const resp = await Services.updateConfig("PUT", JSON.stringify(body), token);
                                                                                setLoading(false);
                                                                                if ((resp && resp.Status === 1) || (resp && resp.status === 1)) {
                                                                                    setData((prev) => prev.map((row) =>
                                                                                        (row.ConfigKey === item.ConfigKey ? { ...row, ConfigValue: editedValue } : row)
                                                                                    ));
                                                                                    setEditingKey(null);
                                                                                    setEditedValue("");
                                                                                    Success("Config updated successfully");
                                                                                } else {
                                                                                    warningSwal("Warning", resp?.Message || "Unable to update config");
                                                                                }
                                                                            } catch (err) {
                                                                                setLoading(false);
                                                                                alert("Something went wrong. Please try again.");
                                                                                console.error(err);
                                                                            }
                                                                        }}
                                                                    >
                                                                        Update
                                                                    </button>
                                                                    <button
                                                                        className={CommonClasses["btnCancel"]}
                                                                        onClick={() => {
                                                                            setEditingKey(null);
                                                                            setEditedValue("");
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <button
                                                                    onClick={() => {
                                                                        setEditingKey(item.ConfigKey || String(index));
                                                                        setEditedValue(item.ConfigValue || "");
                                                                    }}
                                                                >
                                                                    <FaRegEdit />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            <p>No Configs Found</p>
                        </div>
                    )}
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        className={CommonClasses["pagination"]}
                    />
                </div>
            </div>
        </Layout>
    );
};

export default Configs;